// Path: apps/0001-estata.com/frontend/src/lib/rememberEmail.ts
// v1.0.0 - Passcode-Konzept C-5 (docs/website-login-concept.md): die zuletzt erfolgreich angemeldete Adresse bleibt auf
//          dem Geraet - beim naechsten "Anmelden" steht sie vorbelegt unter "Willkommen zurueck", "Nicht du?" leert sie.
//          Nur die Adresse, nie ein Passwort. Speicher kann fehlen (privates Fenster): dann eben leer, nie ein Absturz.
export const REMEMBER_KEY = 'estata.lastEmail';

export function rememberedEmail(): string {
  try { return window.localStorage.getItem(REMEMBER_KEY) || ''; } catch { return ''; }
}

export function rememberEmail(email: string): void {
  const value = (email || '').trim().toLowerCase();
  if (!value) return;
  try { window.localStorage.setItem(REMEMBER_KEY, value); } catch { /* ohne Speicher: nichts merken */ }
}

export function forgetEmail(): void {
  try { window.localStorage.removeItem(REMEMBER_KEY); } catch { /* nichts zu tun */ }
}
